'use strict';
namespace liveChatModule {
    export class LiveChatService {

        private scriptUrl:string = TRPCONFIG.Domain.LiveChat.Script;
        private liveUrl:string = TRPCONFIG.Domain.LiveChat.ChatLocation;
        private interval:number;
        private routeChange:any;

        constructor (
            private loaderService,
            private $rootScope: ng.IRootScopeService
        ) {
            window['_laq'] = window['_laq'] || [];
        }

        public initialise() : void {
            if(typeof this.interval === 'undefined') {
                if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                    console.log(`LIVECHAT | Loading script: ${this.scriptUrl}`);
                }
                this.loaderService.loadJS(window.document, 'script', 'liveChat', this.scriptUrl, true);
                this.interval = setInterval(() => {
                    if (typeof window['liveagent'] !== 'undefined') {
                        const liveChatConfig = TRPCONFIG.Domain.LiveChat;
                        const apiKey = liveChatConfig.ApiKey;
                        const code = liveChatConfig.Code;
                        const site = liveChatConfig.Site;
                        const popupWidth = liveChatConfig.Sizes.Width;
                        const popupHeight = liveChatConfig.Sizes.Height;

                        if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                            console.log(`LIVECHAT | liveagent.addCustomDetail('Site Name', ` +
                                `'${TRPCONFIG.Domain.LiveChat.Site}').saveToTranscript('SiteName__c');`);
                        }
                        window['liveagent'].addCustomDetail('Site Name', site).saveToTranscript('SiteName__c');

                        if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                            console.log(`LIVECHAT | liveagent.setChatWindowWidth(${popupWidth});`);
                            console.log(`LIVECHAT | liveagent.setChatWindowHeight(${popupHeight});`);
                        }
                        window['liveagent'].setChatWindowWidth(popupWidth);
                        window['liveagent'].setChatWindowHeight(popupHeight);

                        //add current page
                        this.newPage();
                        if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                            console.log(`LIVECHAT | liveagent.init('${this.liveUrl}', '${code}', '${apiKey}');`);
                        }
                        window['liveagent'].init(this.liveUrl, code, apiKey);

                        this.routeChange = this.$rootScope.$on('$routeChangeSuccess', () => this.reinit());

                        clearInterval(this.interval);
                        TRPCONFIG.Domain.LiveChat.Ready = true;
                    }
                }, 100);
            }
        }

        reinit(): void {
            this.routeChange();
            this.disconnect();
            TRPCONFIG.Domain.LiveChat.Ready = false;
            delete this.interval;
            delete window['liveagent'];
            delete window['liveAgentDeployment'];

            this.initialise();
        }

        disconnect(): void {
            if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                console.log(`LIVECHAT | liveagent.disconnect();`);
            }
            window['liveagent'].disconnect();
        }

        newPage(): void {
            var currUrl = document.location.href;
            if(TRPCONFIG.Domain.LiveChat.ShowMessages){
                console.log(`LIVECHAT | liveagent.addCustomDetail('Current URL', '${currUrl}')` +
                    `.saveToTranscript('Current_URL__c')`);
            }
            window['liveagent'].addCustomDetail('Current URL', currUrl).saveToTranscript('Current_URL__c');
        }

        startChat(code: string): void {
            if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                console.log(`LIVECHAT | liveagent.startChat('${code}')`);
            }
            window['liveagent'].startChat(code);
        }

        rejectChat(code: string): void {
            if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                console.log(`LIVECHAT | liveagent.rejectChat('${code}')`);
            }
            window['liveagent'].rejectChat(code);
        }

        addReactiveButton(): void {
            window['_laq'].push(() => {
                const reactiveCode = TRPCONFIG.Domain.LiveChat.ReactiveButtonCode;
                const reactiveOfflineCode = TRPCONFIG.Domain.LiveChat.ReactiveOfflineButtonCode;
                if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                    console.log(`LIVECHAT | liveagent.showWhenOnline('${reactiveCode}', ` +
                        `document.getElementById('liveagent_button_online_${reactiveCode}'))`);
                }
                window['liveagent'].showWhenOnline(reactiveCode,
                    document.getElementById(`liveagent_button_online_${reactiveCode}`));

                if(TRPCONFIG.Domain.LiveChat.ShowButtonWhenOffline){
                    if (TRPCONFIG.Domain.LiveChat.ShowMessages) {
                        console.log(`LIVECHAT | liveagent.showWhenOffline('${reactiveCode}', ` +
                            `document.getElementById('liveagent_button_offline_${reactiveOfflineCode}'))`);
                        console.log(`LIVECHAT | liveagent.showWhenOnline('${reactiveOfflineCode}', ` +
                            `document.getElementById('liveagent_button_online_${reactiveOfflineCode}'))`);
                    }
                    window['liveagent'].showWhenOffline(reactiveCode,
                        document.getElementById(`liveagent_button_offline_${reactiveOfflineCode}`));
                    window['liveagent'].showWhenOnline(reactiveOfflineCode,
                        document.getElementById(`liveagent_button_online_${reactiveOfflineCode}`));

                }
            });
        }
    }

    angular
        .module('liveChatModule')
        .service('liveChatService', LiveChatService);

}
